import React, { useEffect, useState } from "react";
import axios from "axios";
import configData from "../config.json";
import { format } from "date-fns";
import Select from "react-select";

const ItemReceive = () => {
  if (localStorage.getItem("branchID") === null) {
    window.location.replace("/");
  }

  const [itemList, setItemList] = useState([]);
  const [filterItemList, setFilterItemList] = useState([]);

  const [itemId, setItemId] = useState("");
  const [qty, setQty] = useState("");
  const [price, setPrice] = useState("");

  const [mrrNo, setMRRNo] = useState("");
  const [mrrDate, setMRRDate] = useState("");

  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [voucher, setVoucher] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const res = await axios.get(
        configData.SERVER_URL + `/itemData/${localStorage.getItem("branchID")}`
      );
      setItemList(res.data);
      setFilterItemList(res.data);
    };
    loadData();
  }, []);

  const handleAdd = () => {
    if (!itemId) return alert("Select item");
    if (!qty || qty <= 0) return alert("Invalid qty");

    const item = itemList.find((i) => String(i.id) === String(itemId));
    if (!item) return;

    setGridData((prev) => [
      ...prev,
      {
        itemId: item.id,
        itemName: item.itemName,
        qty,
        price,
      },
    ]);

    setItemId("");
    setQty("");
    setPrice("");
  };

  const handleSubmit = async () => {
    if (gridData.length === 0) return alert("No items");

    const payload = {
      mrrNo,
      mrrDate: format(new Date(mrrDate), "yyyy-MM-dd"),
      items: gridData,
      branchID: localStorage.getItem("branchID"),
    };

    setLoading(true);
    try {
      const res = await axios.post(
        configData.SERVER_URL + "/mrrEntry",
        payload
      );

      if (res.status === 200) {
        alert("Saved Successfully");
        setVoucher(res.data.voucher.data);
        setGridData([]);
      }
    } catch (e) {
      alert("Error saving");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-3">

      {/* HEADER */}
      <div className="card shadow-sm mb-3">
        <div className="card-header d-flex justify-content-between align-items-center"
                style={{
                background: "linear-gradient(135deg, #0d6efd, #0dcaf0)",
                color: "#fff",
                padding: "18px 25px",
                border: "none",
                }} >
                <div>
                    <h3 className="mb-0 fw-bold">Item Receive (MRR Entry)</h3>
                </div>
        </div>

        <div className="card-body">
          <div className="row g-3">

            <div className="col-md-3">
              <label>MRR No</label>
              <input
                className="form-control"
                value={mrrNo}
                onChange={(e) => setMRRNo(e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <label>MRR Date</label>
              <input
                type="date"
                className="form-control"
                value={mrrDate}
                onChange={(e) => setMRRDate(e.target.value)}
              />
            </div>

          </div>
        </div>
      </div>

      {/* ITEM ENTRY */}
      <div className="card shadow-sm mb-3">
        <div className="card-body">

          <div className="row g-3 align-items-end">

            <div className="col-md-6">
              <label>Item</label>
              <Select
                options={filterItemList.map((it) => ({
                  value: it.id,
                  label: `${it.itemCode} - ${it.itemName}`,
                }))}
                onChange={(opt) => setItemId(opt?.value)}
              />
            </div>

            <div className="col-md-2">
              <label>Price</label>
              <input
                className="form-control"
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <label>Qty</label>
              <input
                className="form-control"
                type="number"
                value={qty}
                onChange={(e) => setQty(e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <button
                className="btn btn-success w-100"
                onClick={handleAdd}
              >
                + Add Item
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm mb-3">
        <div className="card-body table-responsive">

          <table className="table table-bordered table-hover">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Item</th>
                <th>Price</th>
                <th>Qty</th>
                <th width="120">Action</th>
              </tr>
            </thead>

            <tbody>
              {gridData.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No Items Added
                  </td>
                </tr>
              ) : (
                gridData.map((r, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{r.itemName}</td>
                    <td>{r.price}</td>
                    <td>{r.qty}</td>
                    <td>
                      <button className="btn btn-sm btn-danger">
                        Remove
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

        </div>
      </div>

      {/* ACTION BUTTONS */}
      <div className="d-flex gap-2 mb-4">
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Saving..." : "Submit"}
        </button>

        <button
          className="btn btn-secondary"
          onClick={() => setGridData([])}
        >
          Clear
        </button>
      </div>

      {/* VOUCHER */}
      {voucher.length > 0 && (
        <div className="card shadow-sm p-3">
          <h5>📄 Receive Voucher</h5>

          <table className="table table-striped">
            <thead>
              <tr>
                <th>Item</th>
                <th>Price</th>
                <th>Qty</th>
              </tr>
            </thead>
            <tbody>
              {voucher.map((v, i) => (
                <tr key={i}>
                  <td>{v.itemName}</td>
                  <td>{v.mrr_price}</td>
                  <td>{v.mrr_qty}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    </div>
  );
};

export default ItemReceive;